import React, { ImgHTMLAttributes } from "react";

import AppStoreBadge from "@/assets/img/badge-app-store.png";
import GooglePlayBadge from "@/assets/img/badge-google-play.png";
import Lgc from "@/assets/img/lgc.png";
import Libreview from "@/assets/img/libreview.png";
import StetoInfo from "@/assets/img/steto-info-2.png";

export type ImageProps = Omit<
  React.DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  "src" | "alt"
> & { alt: string };
export const Image: (src: string) => React.FC<ImageProps> = src => {
  const _Image: React.FC<ImageProps> = ({ alt, ...props }) => <img src={src} alt={alt} {...props} />;

  return _Image;
};

export const Images = {
  appStoreBadge: Image(AppStoreBadge),
  googlePlayBadge: Image(GooglePlayBadge),
  lgc: Image(Lgc),
  libreview: Image(Libreview),
  stetoInfo: Image(StetoInfo),
};
